/* ============================================================
   Anime Alley, product page JS
   Variant/condition selection, quantity stepper, gallery, tabs.
   AJAX add-to-cart is handled globally by theme.js.
   ============================================================ */
(function () {
  'use strict';
  var theme = window.theme || {};
  var strings = theme.strings || {};

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  qsa('[data-product-form-wrapper]').forEach(function (wrapper) {
    var dataEl = wrapper.querySelector('[data-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var idInput = wrapper.querySelector('[data-variant-id]');
    var priceEl = wrapper.querySelector('[data-price]');
    var atc = wrapper.querySelector('[data-atc]');
    var atcText = wrapper.querySelector('[data-atc-text]');
    var galleryImg = wrapper.querySelector('[data-gallery-image]');
    var stockBadge = wrapper.querySelector('[data-stock-badge]');
    var stickyBar = wrapper.querySelector('[data-sticky-atc]');
    var stickyAdd = wrapper.querySelector('[data-sticky-add]');
    var stickyText = wrapper.querySelector('[data-sticky-text]');
    var stickyPrice = wrapper.querySelector('[data-sticky-price]');

    // Swap the main gallery image. The <img> ships with a srcset (for fast first paint),
    // and browsers render srcset OVER src, so we must clear srcset/sizes or the image
    // never changes when a thumb or variant is selected.
    function setGalleryImage(src, alt) {
      if (!galleryImg || !src) return;
      galleryImg.removeAttribute('srcset');
      galleryImg.removeAttribute('sizes');
      galleryImg.src = src;
      if (alt) galleryImg.alt = alt;
    }

    function selectedOptions() {
      var opts = [];
      qsa('[data-option-input]', wrapper).forEach(function (input) {
        if (input.checked) {
          var pos = parseInt(input.getAttribute('data-option-position'), 10);
          opts[pos - 1] = input.value;
        }
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
    }

    function money(cents) {
      return window.formatMoney ? window.formatMoney(cents) : ('$' + (cents / 100).toFixed(2));
    }

    function updateStockBadge(variant) {
      if (!stockBadge) return;
      var d = stockBadge.dataset;
      var isPreorder = d.preorder === 'true';
      var cls, text;
      if (isPreorder && variant.available) {
        cls = 'pill-blue'; text = d.labelPreorder;
      } else if (!variant.available) {
        cls = 'pill-grey'; text = d.labelOutofstock;
      } else if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny' &&
                 variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
        cls = 'pill-peach'; text = (d.labelLowstock || '').replace('__count__', variant.inventory_quantity);
      } else {
        cls = 'pill-green'; text = d.labelInstock;
      }
      var span = document.createElement('span');
      span.className = 'pill ' + cls;
      span.textContent = text || '';
      stockBadge.innerHTML = '';
      stockBadge.appendChild(span);
    }

    function updateAriaPressed() {
      qsa('[data-option-group]', wrapper).forEach(function (group) {
        qsa('label', group).forEach(function (label) {
          var input = label.querySelector('input');
          if (input) label.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
        });
      });
    }

    function updateOptionAvailability() {
      var current = selectedOptions();
      qsa('[data-option-group]', wrapper).forEach(function (group) {
        var pos = parseInt(group.getAttribute('data-option-position'), 10);
        qsa('[data-option-input]', group).forEach(function (input) {
          var test = current.slice();
          test[pos - 1] = input.value;
          var available = variants.some(function (v) {
            return v.available && v.options.every(function (val, i) { return test[i] == null || val === test[i]; });
          });
          var label = input.closest('label');
          if (available) {
            input.removeAttribute('disabled');
            if (label) label.setAttribute('aria-disabled', 'false');
          } else {
            input.setAttribute('disabled', '');
            if (label) label.setAttribute('aria-disabled', 'true');
          }
        });
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant;
      if (opts.length === 0) {
        // No option pickers on the page (single default variant, e.g. event tickets):
        // match nothing against radios; use the server-selected variant instead.
        // Without this, the init sync found no variant and disabled the buy button
        // on every in-stock single-variant product.
        var currentId = idInput ? parseInt(idInput.value, 10) : NaN;
        variant = variants.find(function (v) { return v.id === currentId; }) || variants[0];
      } else {
        variant = findVariant(opts);
      }
      updateAriaPressed();
      updateOptionAvailability();

      if (!variant) {
        if (idInput) idInput.value = '';
        if (atc) { atc.setAttribute('disabled', ''); }
        if (atcText) atcText.textContent = strings.unavailable || 'Unavailable';
        if (stickyAdd) stickyAdd.setAttribute('disabled', '');
        if (stickyText && atcText) stickyText.textContent = atcText.textContent;
        return;
      }

      if (idInput) idInput.value = variant.id;

      // price
      if (priceEl) {
        var html = money(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s>' + money(variant.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
      }

      // availability
      if (atc) {
        if (variant.available) {
          atc.removeAttribute('disabled');
          if (atcText) atcText.textContent = atc.getAttribute('data-add-label') || strings.addLabel || (atcText.getAttribute('data-default') || 'Add to cart');
        } else {
          atc.setAttribute('disabled', '');
          if (atcText) atcText.textContent = strings.soldOut || 'Sold out';
        }
      }

      // stock badge (keep in lockstep with the ATC button)
      updateStockBadge(variant);

      // sticky mobile bar mirrors the main ATC state
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (stickyAdd) {
        if (variant.available) stickyAdd.removeAttribute('disabled');
        else stickyAdd.setAttribute('disabled', '');
      }
      if (stickyText && atcText) stickyText.textContent = atcText.textContent;

      // url (skip during the initial sync so plain page loads keep a clean address bar)
      if (!initializing && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      // media
      if (variant.featured_media && galleryImg) {
        var src = variant.featured_media.preview_image ? variant.featured_media.preview_image.src : variant.featured_media.src;
        if (src) {
          var sized = src.indexOf('?') > -1 ? src + '&width=660' : src + '?width=660';
          setGalleryImage(sized, variant.featured_media.alt);
        }
      }
    }

    // capture default add label
    if (atcText && !atc.hasAttribute('disabled')) {
      atc.setAttribute('data-add-label', atcText.textContent.trim());
    }

    qsa('[data-option-input]', wrapper).forEach(function (input) {
      input.addEventListener('change', update);
    });

    // initial full sync: server-side badge/price/ATC are product-level, so a deep link
    // to a sold-out variant (?variant=...) would otherwise show "In stock" + enabled ATC.
    var initializing = true;
    if (variants.length) { update(); }
    else { updateAriaPressed(); updateOptionAvailability(); }
    initializing = false;

    /* qty stepper */
    var qtyWrap = wrapper.querySelector('[data-qty]');
    if (qtyWrap) {
      var qtyInput = qtyWrap.querySelector('[data-qty-input]');
      qtyWrap.querySelector('[data-qty-down]').addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1; qtyInput.value = Math.max(1, v - 1);
      });
      qtyWrap.querySelector('[data-qty-up]').addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1; qtyInput.value = v + 1;
      });
    }

    /* gallery thumbs */
    qsa('[data-gallery-thumb]', wrapper).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setGalleryImage(thumb.getAttribute('data-full'), thumb.getAttribute('data-alt'));
        qsa('[data-gallery-thumb]', wrapper).forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });

    /* sticky mobile ATC: visible whenever the inline buy button is off-screen
       (CSS keeps the bar display:none above 860px) */
    var atcRow = wrapper.querySelector('.atc-row');
    if (stickyBar && atcRow && 'IntersectionObserver' in window) {
      var stickyIO = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        stickyBar.classList.toggle('sticky-atc--show', !visible);
        stickyBar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      }, { rootMargin: '-56px 0px 0px 0px' });
      stickyIO.observe(atcRow);
    }
    if (stickyAdd && atc) {
      stickyAdd.addEventListener('click', function () {
        if (!atc.hasAttribute('disabled')) atc.click();
      });
    }

    /* tabs */
    var tabBtns = qsa('[data-tab-btn]', wrapper);
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-tab-btn');
        tabBtns.forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
        qsa('[data-tab-panel]', wrapper).forEach(function (panel) {
          if (panel.getAttribute('data-tab-panel') === idx) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      });
    });
  });
})();
